import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  accountWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  emailField: {
    padding: 20,
    width: '50%',
    flexDirection: 'row',
  },
  bannerWrapper: {
    backgroundColor: colors.newUI.therapist.green10,
    padding: 10,
    borderRadius: 4,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    borderWidth: 1,
    borderColor: colors.primary,
  },
  showMoreText: {
    color: colors.primary,
    fontWeight: 500,
    fontSize: 18,
  },
  showMoreBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 12,
  },
  infoWrapper: {
    flexDirection: 'row',
    padding: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  deleteAccountText: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 10,
    color: colors.red,
  },
  fieldWrapper: {
    borderWidth: 2,
    padding: 10,
    borderRadius: 4,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 10,
    marginTop: 20,
  },
  inputWrapper: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    marginTop: 20,
  },
  deviceText: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 10,
  },
  verifiedFieldWrapper: {
    borderColor: colors.primary,
    backgroundColor: colors.newUI.therapist.green10,
  },
  unverifiedFieldWrapper: {
    borderColor: colors.newUI.therapist.grey30,
    backgroundColor: colors.newUI.therapist.grey20,
  },
  emailWrapper: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    gap: 20,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  verifiedEmail: {
    fontSize: 18,
    color: colors.newUI.therapist.textBlue100,
    flexShrink: 1,
    minWidth: 0,
  },
  unverifiedEmail: {
    fontSize: 18,
    fontStyle: 'italic',
    color: colors.newUI.therapist.grey70,
    flexShrink: 1,
    minWidth: 0,
  },
  pillWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginTop: 4,
    borderWidth: 2,
    padding: 5,
    borderRadius: 20,
  },
  verifiedPillWrapper: {
    borderColor: colors.primary,
    backgroundColor: colors.newUI.therapist.green10,
  },
  unverifiedPillWrapper: {
    borderColor: colors.newUI.therapist.yellow90,
    backgroundColor: colors.newUI.therapist.yellow10,
  },
  buttonWrapper: {
    flexShrink: 0,
    flexDirection: 'row',
    gap: 10,
    marginLeft: 'auto',
  },
});
